<template>
  <v-row justify="center">
    <v-col class="auth-container">
      <v-row class="ma-2"><slot name="logo"></slot></v-row>
      <v-row class="ma-0 pa-0"></v-row>
      <v-card class="elevation-12" tile>
        <v-row class="ma-0 pa-0">
          <v-col cols="8" class="ma-0 pa-0">
            <v-form
              ref="form"
              style="height: 100%"
              v-model="valid"
              @submit.prevent="valid && signIn()"
            >
              <v-card-title>
                <h1>Sign in</h1>
              </v-card-title>
              <v-card-subtitle>
                <h2 class="mt-2">Please enter your details</h2>
              </v-card-subtitle>
              <v-card-text>
                <v-text-field
                  filled
                  autocomplete="email"
                  v-model="email"
                  name="email"
                  label="Email address"
                  type="email"
                  class="hint"
                  :rules="[rules.required, rules.email]"
                  required
                ></v-text-field>

                <v-card-text></v-card-text>
              </v-card-text>
              <v-card-actions class="pb-2">
                <v-spacer />
                <v-btn
                  type="submit"
                  :disabled="!valid"
                  :loading="loading"
                  color="primary"
                  class="button"
                  tile
                  elevation="0"
                  >Email my sign in link</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-col>
          <v-col cols="4" class="pt-12">
            <v-img
              :src="require('@/assets/images/img-registration-one@3x.png')"
              max-width="293px"
              max-height="342px"
            ></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { functions } from '@/firebaseConfig'
import { textFieldRules } from '@/common'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showPass: false,
      valid: false,
      loading: false,
      rules: textFieldRules,
    }
  },

  methods: {
    ...mapActions(['setEmailForSignIn', 'showError']),
    async getUserInfo(id) {
      await this.$store.dispatch('getUserInfo', id)
      this.loading = false
      this.$router.replace({ name: 'launchpad' })
    },
    async signIn() {
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          const emailSignInLink = functions.httpsCallable('auth-emailSignIn')
          await emailSignInLink({ email: this.email })
          this.$store.dispatch('setEmailForSignIn', this.email)
          this.$router.push({
            name: 'signin-check-email',
          })
        } catch (err) {
          console.error(err)
          this.showError(
            '<b>Failed to send email link.</b>\n' + err.message ??
              'Please try again later or contact our support.'
          )
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.mtoolbar
  background: #fff
  color: #fff
  background-color: #fff
</style>
